import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Fab,
  FormControlLabel,
  TextField,
  Typography,
  Zoom,
  useMediaQuery,
} from "@mui/material";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import Flexbetween from "components/FlexBetween";
import Navbar from "scenes/navbar";
import { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDatas, setPage, setRef, setValidateExactData } from "state";
import {
  fieldLabels,
  formConstants,
  formulaireSasu1,
} from "constants/form.constants";
import AddressSearch from "components/AddressSearch";
import apiService from "services/apiService";
import NavigationBar from "components/NavigationBar";
import StripeProducts from "components/StripeProducts";
import { InfoOutlined } from "@mui/icons-material";
import InfoDialog from "components/InfoDialog";
import ARadioGroup from "components/ARadioGroup";
import EmptyDialog from "components/emptyDialog";

import direction from "../../assets/direction.mp4";
import recapitulatif from "../../assets/recapitulatif.mp4";
import introduction_outil from "../../assets/introduction_outil.mp4";
import tunnel1_q5 from "../../assets/tunnel1_q5.mp4";
import tunnel1_q6 from "../../assets/tunnel1_q6.mp4";
import tunnel1_q7 from "../../assets/tunnel1_q7.mp4";
import tunnel1_q9 from "../../assets/tunnel1_q9.mp4";

import preview1 from "../../assets/preview1.jpg";
import preview2 from "../../assets/preview2.jpg";
import preview5 from "../../assets/preview5.jpg";
import preview7 from "../../assets/preview7.jpg";
import preview8 from "../../assets/preview8.jpg";
import preview9 from "../../assets/preview9.jpg";

import img_2 from "../../assets/img_2.jpg";
import img_3 from "../../assets/img_3.jpg";
import img_4 from "../../assets/img_4.jpg";
import img_5 from "../../assets/img_5.jpg";
import img_6 from "../../assets/img_6.jpg";
import img_7 from "../../assets/img_7.jpg";
import img_10 from "../../assets/img_10.jpg";
import CookiePopup from "components/CookiePopup.js";

const Homepage = () => {
  const largeScreen = useMediaQuery("(min-width: 800px)");
  const dispatch = useDispatch();
  const ref = useSelector((state) => state.ref);
  const page = useSelector((state) => state.page);
  const datas = useSelector((state) => state.datas);
  const validateExactData = useSelector((state) => state.validateExactData);

  useEffect(() => {
    const fetchToken = async () => {
      try {
        const { data, error } = await apiService.postData("/auth/register");
        if (error) {
          console.error(error);
        }
        if (data) {
          dispatch(setRef({ ref: data.ref }));
        }
      } catch (error) {
        console.error(error);
      }
    };

    if (!ref) {
      fetchToken();
    }
  }, [ref, dispatch]);

  const updateUserData = async (formData) => {
    try {
      const { data, error } = await apiService.postData(
        "/users/addOrUpdateUser",
        formData
      );
      if (error) {
        console.error(error);
      }

      if (data) {
        console.log("update user data successfully");
      }
    } catch (error) {
      console.error(
        "Erreur lors de la création de la session Checkout:",
        error
      );
    }
  };

  const isStepEnable = (step) => {
    if (step > 1 && !isStepEnable(step - 1)) {
      return false;
    }

    switch (step) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
      case 8:
        const formQuestions = formulaireSasu1[step - 1].form?.questions || [];
        return formQuestions.every((question) => {
          const value = datas[question.key];
          const condition = question.condition;
          if (condition && datas[condition.key] !== condition.value) {
            return true;
          }
          return value !== undefined && value !== "";
        });
      case 9:
        return isStepEnable(8) && validateExactData;
      case 10:
        return true;
      case 11:
        return (
          isStepEnable(1) &&
          isStepEnable(2) &&
          isStepEnable(3) &&
          isStepEnable(4) &&
          isStepEnable(5) &&
          isStepEnable(6) &&
          isStepEnable(7) &&
          isStepEnable(8) &&
          isStepEnable(9)
        );
      default:
        return true;
    }
  };

  const formRender = () => {
    const updateState = (key, value) => {
      console.log("updateState", key, value);
      const newDatas = Object.assign({}, datas);
      if (value === null || value === undefined) {
        delete newDatas[key];
      } else {
        newDatas[key] = value;
      }
      if (key === "firstTimeCreation" && value === "Oui") {
        delete newDatas["previousCreation"];
      }

      if (key === "nommerDirecteurGeneral" && value === "Non") {
        delete newDatas["identiteDirecteur"];
      }

      if (key === "dateExercice") {
        delete newDatas["dateClotureExceptionnelle"];
      }
      dispatch(setDatas({ datas: newDatas }));
      updateUserData(newDatas);
    };

    const formQuestions = formulaireSasu1[page - 1].form?.questions || [];
    const formType = formulaireSasu1[page - 1].form?.type;

    if (formType === "recapitulatif") {
      return (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "0px",
          }}
        >
          {formulaireSasu1.map((section, index) => {
            if (["recapitulatif", "stripe"].includes(section.form.type)) {
              return null;
            }
            return (
              <Box sx={{ mb: "30px", width: "100%" }}>
                <Typography key={section.label} variant="h2">
                  {section.label}
                </Typography>
                {section.form?.questions?.map((question) => {
                  const value = datas[question.key];
                  if (!value) {
                    return null;
                  }
                  return (
                    <Flexbetween
                      sx={{
                        gap: "5px",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (index !== -1) {
                          dispatch(setPage({ page: index + 1 }));
                        }
                      }} // Naviguer vers la page correspondante
                    >
                      <Typography>{fieldLabels[question.key]}:</Typography>
                      <Typography variant="h6">{value}</Typography>
                    </Flexbetween>
                  );
                })}
              </Box>
            );
          })}

          <FormControlLabel
            control={
              <Checkbox
                checked={validateExactData}
                onChange={(e) => {
                  dispatch(
                    setValidateExactData({
                      validateExactData: e.target.checked,
                    })
                  );
                }}
              />
            }
            label={
              <Typography>
                Je certifie sur l’honneur que les informations fournies sont
                exactes et sincères et Je reconnais avoir pris connaissance des{" "}
                <a
                  href="https://www.alceeavocats.com/conditions-generales-de-vente/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Conditions Générales de Vente
                </a>{" "}
                et les accepte sans réserve.
              </Typography>
            }
          />
        </Box>
      );
    } else if (formType === "stripe") {
      return <StripeProducts />;
    }

    return formQuestions.map((question) => {
      if (question.condition) {
        if (datas?.[question.condition.key] !== question.condition.value) {
          return null;
        }
      }
      if (question.key === "dateClotureExceptionnelle") {
        // si la fin de la date d'exercice est dans plus de 6 mois, on affiche n +1 et n+2
        // ex : "1er janvier au 31 décembre",

        const dateExercice = datas?.["dateExercice"];
        if (!dateExercice) {
          return null;
        }
        const dateFinExercice = dateExercice.split(" au ")[1]; // "31 décembre"
        if (!dateFinExercice) {
          return null;
        }

        const monthEnd = parseInt(dateFinExercice.split(" ")[0]); // "31"
        const monthName = dateFinExercice.split(" ")[1]; // "décembre"
        const monthMap = {
          janvier: 1,
          février: 2,
          mars: 3,
          avril: 4,
          mai: 5,
          juin: 6,
          juillet: 7,
          août: 8,
          septembre: 9,
          octobre: 10,
          novembre: 11,
          décembre: 12,
        };

        const monthEndNumber = monthMap[monthName];
        if (!monthEndNumber) {
          return null;
        }

        // la date de fin d'exercice est égale à la dateFinExercice de l'année en cours
        // si le mois de la date de fin d'exercice est déja passé cette année, on ajoute 1 an
        // si la date de fin d'exercice est dans plus de 6 mois, on propose n de la date de fin et n+1
        // si la date de fin d'exercice est dans moins de 6 mois, on propose uniquement n de la date de fin + 1
        const now = new Date();
        let yearEnd = now.getFullYear();
        if (
          monthEndNumber < now.getMonth() + 1 ||
          (monthEndNumber === now.getMonth() + 1 && monthEnd < now.getDate())
        ) {
          yearEnd += 1;
        }

        const endDateThisYear = new Date(yearEnd, monthEndNumber, monthEnd);
        const diffTime = endDateThisYear - now;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        let options = [];

        if (diffDays > 180) {
          options = [
            `${monthEnd} ${monthName} ${yearEnd}`,
            `${monthEnd} ${monthName} ${yearEnd + 1}`,
          ];
        } else {
          options = [`${monthEnd} ${monthName} ${yearEnd + 1}`];
        }

        return (
          <Box key={question.key} sx={{ width: "100%", mb: "20px" }}>
            <Typography sx={{ mb: "10px" }}>
              {fieldLabels[question.key]}
            </Typography>
            <ARadioGroup
              name={question.key}
              choices={options}
              value={datas?.[question.key] ?? null}
              onChange={(v) => updateState(question.key, v)}
            />
          </Box>
        );
      }
      if (question.type === "textfield") {
        return (
          <TextField
            key={question.key}
            value={datas?.[question.key]}
            onChange={(e) => updateState(question.key, e.target.value)}
            fullWidth
            label={fieldLabels[question.key]}
            name={question.key}
          />
        );
      } else if (question.type === "numberfield") {
        return (
          <TextField
            key={question.key}
            type="number"
            value={datas?.[question.key]}
            onChange={(e) => updateState(question.key, e.target.value)}
            fullWidth
            label={fieldLabels[question.key]}
            name={question.key}
          />
        );
      } else if (question.type === "radio") {
        return (
          <Box>
            {question.displayLabel && (
              <Typography>{fieldLabels[question.key]}</Typography>
            )}
            <ARadioGroup
              name={question.key}
              choices={question.options}
              value={datas?.[question.key] ?? null}
              onChange={(v) => updateState(question.key, v)}
            />
          </Box>
        );
      } else if (question.type === "activityList") {
        return (
          <Autocomplete
            key={question.key}
            disablePortal
            id={question.key}
            options={formConstants.ACTIVITY_LIST}
            value={datas?.[question.key]}
            fullWidth
            onChange={(event, value) => updateState(question.key, value)}
            renderInput={(params) => (
              <TextField {...params} label={fieldLabels[question.key]} />
            )}
            ListboxProps={{
              style: {
                maxHeight: "150px",
              },
            }}
          />
        );
      } else if (question.type === "address") {
        return (
          <AddressSearch
            key={question.key}
            defaultValue={datas?.[question.key]}
            label={fieldLabels[question.key]}
            onSelectionChange={(address) => {
              updateState(question.key, address?.properties?.label);
            }}
          />
        );
      } else if (question.type === "calendar") {
        return (
          <TextField
            key={question.key}
            type="date"
            value={datas?.[question.key]}
            onChange={(e) => updateState(question.key, e.target.value)}
            fullWidth
            label={fieldLabels[question.key]}
            name={question.key}
            InputLabelProps={{ shrink: true }}
          />
        );
      }

      return null;
    });
  };

  const formulaireRender = () => {
    return (
      <Fragment>
        <Flexbetween
          sx={{
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "10px",
          }}
        >
          <Typography
            variant={largeScreen ? "h3" : "h4"}
            sx={{ fontWeight: 600 }}
          >
            {formulaireSasu1[page - 1].form?.title}
          </Typography>
          {page < 10 && (
            <Typography variant="h5">
              Ces informations nous permettront de vous assister au cours de
              votre processus de création, et seront necessaires pour constituer
              votre dossier.
            </Typography>
          )}
        </Flexbetween>
        {formRender()}
        <Flexbetween gap={2}>
          {page > 1 && (
            <Button
              onClick={() => {
                if (page > 1) {
                  dispatch(setPage({ page: page - 1 }));
                }
              }}
              variant="contained"
            >
              retour
            </Button>
          )}
          {page < 10 && (
            <Button
              sx={{ pl: "24px", pr: "24px" }}
              onClick={() => {
                if (page < 10) {
                  dispatch(setPage({ page: page + 1 }));
                }
              }}
              disabled={!isStepEnable(page)}
              variant="contained"
              endIcon={<ArrowRightAltIcon />}
            >
              Continuer
            </Button>
          )}
        </Flexbetween>
        <InfoDialog
          title="Information sur vos données"
          message="Vos données sont protégées par la loi : Alcée Avocats, éditeur du site  collecte des données personnelles à l'aide du présent questionnaire afin d'assurer les services proposés sur le site. Vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition au traitement des données à caractère personel vous concernant. Vous pouvez exercer ces droits à l'adresse email suivante: contact@alceeavocats.com . Pour plus d'information, veuillez consulter notre politique de données personnelles."
        >
          <Flexbetween gap="10px">
            <InfoOutlined />
            Information sur vos données
          </Flexbetween>
        </InfoDialog>
      </Fragment>
    );
  };

  const getvideoSrc = () => {
    if (page === 1) return introduction_outil;
    if (page === 5) return tunnel1_q5;
    if (page === 6) return tunnel1_q6;
    if (page === 7) return tunnel1_q7;
    if (page === 8) return direction;
    if (page === 9) return tunnel1_q9;
    return recapitulatif;
  };

  const getVideoPoster = () => {
    if (page === 1) return preview1;
    if (page === 5) return preview5;
    if (page === 6) return preview2;
    if (page === 7) return preview7;
    if (page === 8) return preview8;
    if (page === 9) return preview9;
    return preview1;
  };

  const getImgSrc = () => {
    if (page === 2) return img_2;
    if (page === 3) return img_3;
    if (page === 4) return img_4;
    if (page === 5) return img_5;
    if (page === 6) return img_6;
    if (page === 7) return img_7;
    if (page === 10) return img_10;
    return null;
  };

  const isVideoPage = () => {
    return [1, 5, 6, 7, 8, 9].includes(page);
  };

  const videoCard = () => {
    if (largeScreen) {
      return (
        <Box
          sx={{
            borderRadius: "16px",
            aspectRatio: "0.56",
            height: "80%",
            maxHeight: "400px",
            overflow: "hidden",
            position: "sticky",
            top: "220px",
          }}
        >
          {isVideoPage() ? (
            <video
              id="video"
              style={{ objectFit: "cover", objectPosition: "center" }}
              width="100%"
              height="100%"
              controls
              poster={getVideoPoster()}
              src={getvideoSrc()}
            />
          ) : (
            <img
              style={{ objectFit: "cover", objectPosition: "center" }}
              width="100%"
              height="100%"
              alt="presentation"
              src={getImgSrc()}
            />
          )}
        </Box>
      );
    } else {
      if (isVideoPage()) {
        return (
          <Box sx={{ position: "fixed", bottom: 10, right: 5, opacity: 1 }}>
            <EmptyDialog
              content={
                <Box
                  sx={{
                    borderRadius: "16px",
                    aspectRatio: "0.56",
                    height: "80%",
                    maxHeight: "400px",
                    overflow: "hidden",
                  }}
                >
                  <video
                    style={{ objectFit: "cover", objectPosition: "center" }}
                    width="100%"
                    height="100%"
                    controls
                    autoPlay
                    poster={getVideoPoster()}
                    src={getvideoSrc()}
                  />
                </Box>
              }
            >
              <Zoom
                key="inherit"
                in={true}
                timeout={100}
                style={{
                  transitionDelay: "100ms",
                }}
                unmountOnExit
              >
                <Fab
                  sx={{
                    color: "common.white",
                    backgroundImage: `url(${getVideoPoster()})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                  }}
                  aria-label="Expand"
                  color="inherit"
                >
                  <Typography
                    sx={{
                      backgroundColor: "#0000001a",
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "12px",
                      fontWeight: "bold",
                      borderRadius: "50%",
                    }}
                  >
                    Play
                  </Typography>
                </Fab>
              </Zoom>
            </EmptyDialog>
          </Box>
        );
      }
      return null;
    }
  };

  return (
    <Box sx={{ height: "100%", overflowY: "scroll" }}>
      <CookiePopup />
      <Box
        sx={{
          position: "sticky",
          top: 0,
          backgroundColor: "#FFF",
          zIndex: 999,
        }}
      >
        <Navbar />
        <NavigationBar isStepEnable={(index) => isStepEnable(index)} />
      </Box>
      <Flexbetween
        sx={{
          justifyContent: "center",
          gap: "4rem",
          alignItems: "flex-start",
          minHeight: "calc(100% - 120px)",
        }}
      >
        {videoCard()}
        <Box
          sx={{
            width: largeScreen ? (page === 11 ? "50%" : "40%") : null,
            padding: "20px",
            mt: "50px",
          }}
        >
          <Flexbetween
            sx={{ flexDirection: "column", alignItems: "flex-start", gap: 4 }}
          >
            {formulaireRender()}
          </Flexbetween>
        </Box>
      </Flexbetween>
    </Box>
  );
};

export default Homepage;
